function init() {
  if (!window.storySettings) return

  const header = document.querySelector('sticky-header');
  const nav = document.querySelector('.brand_nav');
  const sections = document.querySelectorAll('.story-container');
  let scrollingTo = false;
  

  function fillTitles(sections) {
    sections.forEach(s => {
      const title = s.getAttribute('data-title')
      if (title.length < 1) return;
      const html = `<a class="brand-section-title" href="#section-${title}">${title}</a>`
      
      document.querySelector('.brand_nav').insertAdjacentHTML('beforeend', html)
    })
  }

  function navHighlighter(sections) {
    let scrollY = window.pageYOffset;
  
    sections.forEach(current => {
      if (current.dataset.title < 1) return;
      const headerHeight = +header.getBoundingClientRect().height;
      const navHeight = +nav.getBoundingClientRect().height;
      const announcementBar = +document.querySelector('[id^="shopify-section-sections--"][id$="__announcement-bar"]').getBoundingClientRect().height
      const sectionHeight = current.offsetHeight;
      const sectionTop = current.offsetTop - headerHeight - navHeight - announcementBar - 20;
      const sectionId = current.getAttribute("id");
      const navWidth = +nav.getBoundingClientRect().width
      const navPosition = nav.getBoundingClientRect().x;
      
      if (
        scrollY > sectionTop &&
        scrollY <= sectionTop + sectionHeight &&
        ! scrollingTo
      ) {
        let title = document.querySelector(`.brand_nav a[href*="#${sectionId}"`)
        title.classList.add("active");
        let titlePosition = title.getBoundingClientRect().x;
        let titleWidth = title.getBoundingClientRect().width;

        if (+nav.scrollLeft + navWidth - (navWidth * 0.3) < titlePosition) {
          nav.scrollTo(titlePosition, 0)
        } else if (titlePosition < navPosition) {
          nav.scrollTo(titlePosition, 0)
        }
      } else if (scrollingTo) {
        document.querySelector(`.brand_nav a[href*="#${sectionId}"`).classList.remove("active");
        document.querySelector(`.brand_nav a[href*="${scrollingTo}"`).classList.add("active")
        let scrollingSection = document.querySelector(scrollingTo)
        const scrollingToTop = scrollingSection.offsetTop - headerHeight - navHeight - announcementBar - 20;
        if (
          scrollY > scrollingToTop && 
          scrollY <= scrollingToTop + scrollingSection.offsetHeight
        ) {
          scrollingTo = false
        }

      } else {
        document.querySelector(`.brand_nav a[href*="#${sectionId}"`).classList.remove("active");
      }
    })
  }

  nav.addEventListener('click', (e) => {
    if (e.target.closest('a.brand-section-title')) {
      e.preventDefault();
      const headerHeight = +header.getBoundingClientRect().height;
      const navHeight = +nav.getBoundingClientRect().height;
      const announcementBar = +document.querySelector('[id^="shopify-section-sections--"][id$="__announcement-bar"]').getBoundingClientRect().height
      const id = e.target.closest('a.brand-section-title').getAttribute('href');
      const section = document.querySelector(id);
      const y = section.getBoundingClientRect().top + window.scrollY - headerHeight - navHeight - announcementBar;
      window.scrollTo({
        top: y,
        behavior: "smooth"
      })
      scrollingTo = id
    }

  })

  fillTitles(sections)
  navHighlighter(sections)

  window.addEventListener('scroll', (e) => {
    navHighlighter(sections)
  })
}


export default init;